import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MultiEditPropertyTooltipContentComponent } from '../components/multi-edit-property-tooltip-content/multi-edit-property-tooltip-content.component';

@Directive({
  selector: '[appMultiEditPropertyTooltip]',
  standalone: false
})
export class MultiEditPropertyTooltipDirective implements OnInit, OnDestroy {
  @Input('appMultiEditPropertyTooltip') propertyKey: string;

  private overlayRef: OverlayRef;

  constructor(private overlay: Overlay, private overlayPositionBuilder: OverlayPositionBuilder, private elementRef: ElementRef) {}

  ngOnInit(): void {
    const positionStrategy = this.overlayPositionBuilder.flexibleConnectedTo(this.elementRef).withPositions([
      {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
        offsetY: 5
      }
    ]);

    this.overlayRef = this.overlay.create({ positionStrategy });
  }

  @HostListener('mouseenter')
  show(): void {
    if (this.overlayRef && !this.overlayRef.hasAttached()) {
      const tooltipRef = this.overlayRef.attach(new ComponentPortal(MultiEditPropertyTooltipContentComponent));
      tooltipRef.instance.propertyKey = this.propertyKey;
    }
  }

  @HostListener('mouseleave')
  hide(): void {
    this.close();
  }

  ngOnDestroy(): void {
    this.close();
  }

  private close(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
    }
  }
}
